import React from "react"
import ReactAudioPlayer from 'react-audio-player'

const Player = ({src}) =>{
    let fqSrc = `${src}`
    return (
        <ReactAudioPlayer src={fqSrc} controls />
    )
}

export default Player